<template>
  <div>
    <div class="d-flex justify-space-between mb-4">
      <div>
        <div class="page-title mb-2">ปฏิทินกิจกรรม</div>
      </div>
      <div class="d-flex flex-column gap-12">
      <div class="d-flex gap-12">
        <div style="max-width: 250px">
          <TextField hide-details placeholder="ค้นหา" append-icon="ic:baseline-search" @onChange="keyword = $event"
            @onEnter="getDataSearch()"></TextField>
        </div>
      </div>
    </div>
  </div>

    <v-toolbar flat class="transparent">
      <v-btn small depressed fab color="#fff" width="24" height="24" style="background-color: #f65f3c" @click="prev">
        <v-icon small class="white--text">
          mdi-chevron-left
        </v-icon>
      </v-btn>
      <v-toolbar-title v-if="$refs.calendar" class="px-5">
        {{ formatTitle() }}
      </v-toolbar-title>
      <v-btn small depressed fab color="#fff" width="24" height="24" style="background-color: #f65f3c" @click="next">
        <v-icon small class="white--text">
          mdi-chevron-right
        </v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <Button @onClick="createCalendarActivity">+ เพิ่มกิจกรรม</Button>
    </v-toolbar>

    <div class="d-flex justify-end my-4">
      <!-- legend -->
      <div class="d-flex align-center gap-16">
        <div
          v-for="eventType in eventTypeConstant"
          :key="eventType.value"
          class="d-flex align-center gap-8"
        >
          <div
            class="region-dot"
            :style="{ backgroundColor: eventType.color }"
          ></div>
          <span class="region-text">{{ eventType.text }}</span>
        </div>
      </div>
    </div>

    <divcard class="mt-5">
      <v-container>
        <!-- ปฏิทิน -->

        <v-sheet min-height="600">

          <v-calendar class="custom-calendar" v-model="selectedDate" ref="calendar" :events="events"
            :event-name="getEventName" :event-color="getEventColor" :event-text-color="getEventTextColor"
            :event-height="40" :day-class="getDayClass" event-overlap-mode="stack" @click:event="showEventDetails">
            <template #event="{ event, on, attrs }">
              <v-tooltip bottom>
                <template #activator="{ on: tooltipOn }">
                  <div
                    v-bind="attrs"
                    v-on="{
                      ...on,
                      ...tooltipOn
                    }"
                    class="event"
                  >
                    {{ getEventName(event) }}
                  </div>
                </template>
                <span>{{ event.name }}</span>
              </v-tooltip>
            </template>
          </v-calendar>
        </v-sheet>

        <!-- Modal สำหรับแสดงรายละเอียดกิจกรรม -->
        <v-dialog v-model="dialog" max-width="800px">
          <v-card class="px-5 py-5">

            <v-card-title class="font-24 theme-color-one pb-0">{{ selectedEvent.name || 'ไม่มีข้อมูลกิจกรรม'
              }}</v-card-title>

            <v-card-actions class="flex justify-end pt-0">
              <v-btn v-if="canEditEvent(selectedEvent)" small icon @click="editCalendarActivity">
                <Icon class="font-20 theme-color-seven" style="color: #b1b1b1" icon="fe-edit" />
              </v-btn>
              <v-btn v-if="canEditEvent(selectedEvent)" small icon @click="onDelete">
                <Icon class="font-20 theme-color-seven" style="color: #b1b1b1" icon="tabler:trash-x-filled" />
              </v-btn>
              <v-btn small icon @click="dialog = false">
                <Icon class="font-20 theme-color-seven" style="color: #b1b1b1" icon="fa:close" />
              </v-btn>
            </v-card-actions>

            <v-card-text>
              <div class="d-flex flex-column py-5">
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      วันที่เริ่ม
                    </div>
                    <TextField theme="3" :value="formatDate(selectedEvent.start)" :readonly="true" />
                  </div>
                  <div class="flex">
                    <div class="mb-1 black--text">
                      จนถึง
                    </div>
                    <TextField theme="3" :value="formatDate(selectedEvent.end)" :readonly="true" />
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      เวลาที่เริ่ม
                    </div>
                    <TextField theme="3" :value="formatTime(selectedEvent.startTime)" :readonly="true" />
                  </div>
                  <div class="flex">
                    <div class="mb-1 black--text">
                      จนถึง
                    </div>
                    <TextField theme="3" :value="formatTime(selectedEvent.endTime)" :readonly="true" />
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      ผู้จัดกิจกรรม
                    </div>
                    <TextField theme="3" :value="selectedEvent.organizer" :readonly="true" />
                  </div>
                  <div class="flex">
                    <div class="mb-1 black--text">
                      ประธานกิจกรรม
                    </div>
                    <TextField theme="3" :value="selectedEvent.event_leader" :readonly="true" />
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      แนบลิงค์
                    </div>
                    <TextField theme="3" :value="selectedEvent.location_link" :readonly="true" />
                  </div>
                  <div class="flex">
                    <div class="mb-1 black--text">
                      เบอร์โทร ผู้ประสานงาน
                    </div>
                    <TextField theme="3" :value="selectedEvent.coordinator_phone" :readonly="true" />
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      สถานที่จัดกิจกรรม
                    </div>
                    <TextField theme="3" :value="selectedEvent.location" :readonly="true" />
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      ผู้เข้าร่วม
                    </div>
                    <TextArea theme="3" :value="selectedEvent.participants" :readonly="true" />
                  </div>
                </div>
                <div class="flex-center gap-16">
                  <div class="flex">
                    <div class="mb-1 black--text">
                      รายละเอียด
                    </div>
                    <TextArea theme="3" :value="selectedEvent.details" :readonly="true" />
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-container>
    </divcard>
  </div>
</template>

<script>

import TextField from "@/components/input/TextField.vue";
import Button from '@/components/input/Button'
import TextArea from '@/components/input/TextArea'
import { Icon } from "@iconify/vue2";
import { format,addMonths } from "date-fns"; // ใช้ date-fns สำหรับจัดการวันที่

export default {
  name: 'CalendarActivity',
  components: {
    Icon,
    Button,
    TextField,
    TextArea
  },
  data() {
    return {
      keyword: "",
      selectedDate: new Date().toISOString().substring(0, 10), // วันที่ที่เลือกในปฏิทิน
      dialog: false, // เปิด/ปิด Modal
      selectedEvent: {}, // ข้อมูลกิจกรรมที่เลือก
      events: [

      ],
      searchMonth: '',
      searchYear: '',
      eventTypeConstant: [
        { text: "ภาคเหนือ", color: "#FDD835", textColor: "#fff" }, // สีเหลือง
        { text: "ภาคตะวันออกเฉียงเหนือ", color: "#F44336", textColor: "#fff" }, // สีแดง
        { text: "ภาคตะวันออกเฉียงเหนือตอนล่าง", color: "#FF9800", textColor: "#fff" }, // สีส้ม
        { text: "ภาคใต้", color: "#2196F3", textColor: "#fff" }, // สีฟ้า
        { text: "สป.อว", color: "#9E9E9E", textColor: "#fff" } // สีเทา
      ]
    };
  },
  created() {
  
    this.getData();
    
  },
  methods: {
    formatTitle() {
      return format(new Date(this.selectedDate), "MMMM, yyyy");
    },
    async getDataSearch() {
      this.getData(this.searchMonth,this.searchYear);
    },
    async getData(month = null,year = null) {
      // ดึงข้อมูลกิจกรรมจาก API
      if(month == null){
        month = new Date().getMonth() + 1;
        this.searchMonth = month;
      }
      if(year == null){
        year = new Date().getFullYear();
        this.searchYear = year;
      }
      let res = await this.$apiFire("CalendarActivity/index",{
        month: month,
        year: year,
        keyword: this.keyword,
      });
      if (res) {
        this.events = res.data;
      }else{
        this.events = [];
      }

      this.$nextTick(() => {
        if(this.selectedDate != new Date().toISOString().substring(0, 10)){
          const elements = document.querySelectorAll('.v-present');
          elements.forEach((element) => {
            element.classList.add('v-present-inactive');
          });
        }else{
          const elements = document.querySelectorAll('.v-present');
          elements.forEach((element) => {
            element.classList.remove('v-present-inactive');
          });
        }
      });
    },
    createCalendarActivity() {
      this.$router.push({ name: 'CalendarActivityCreate' })
    },
    // ฟังก์ชันสำหรับเลือกสีของกิจกรรม
    getEventColor(event) {
      // ถ้าเป็น สป และ region เป็น null ให้ใช้สีเทา
      if ((event.user_type === "สป.อว." || event.user_type?.includes("สป")) && !event.region) {
        return "#9E9E9E"; // สีเทา
      }

      // ถ้ามี region ให้ใช้สีตาม region
      if (event.region) {
        const regionType = this.eventTypeConstant.find(e => e.text === event.region);
        if (regionType) return regionType.color;
      }

      // ถ้าไม่มี region ให้เช็คจาก user_type
      const userType = this.eventTypeConstant.find(e => e.text === event.user_type);
      if (userType) return userType.color;

      // ค่าเริ่มต้น
      return event.color || "#FDECE7";
    },
    getEventTextColor(event) {
      // ถ้าเป็น สป และ region เป็น null ให้ใช้สีขาว
      if ((event.user_type === "สป.อว." || event.user_type?.includes("สป")) && !event.region) {
        return "#fff"; // สีขาว
      }

      // ถ้ามี region ให้ใช้สีตาม region
      if (event.region) {
        const regionType = this.eventTypeConstant.find(e => e.text === event.region);
        if (regionType) return regionType.textColor;
      }

      // ถ้าไม่มี region ให้เช็คจาก user_type
      const userType = this.eventTypeConstant.find(e => e.text === event.user_type);
      if (userType) return userType.textColor;

      // ค่าเริ่มต้น
      return event.textColor || "#F65F3C";
    },
    getEventName(event) {
      return `${event.startTime || ""} ${event.name}`;
    },
    // แสดง Modal เมื่อคลิกกิจกรรม
    showEventDetails({ event }) {
      this.selectedEvent = event;
      this.dialog = true;
    },
    // เพิ่มคลาสสำหรับวันที่พิเศษ (วันที่ปัจจุบัน)
    getDayClass(day) {
      const today = new Date().toISOString().split("T")[0];
      return day.date === today ? "today" : "";
    },
    // ฟังก์ชันจัดการวันที่ให้อยู่ในรูปแบบที่อ่านง่าย
    formatDate(date) {
      if (!date) return "-";
      return format(new Date(date), "MMMM do, yyyy");
    },
    //format time am/pm
    formatTime(time) {
      if (time == undefined) {
        return '-';
      } else {
        let [hours, minutes] = time.split(':').map(Number);

        // Validate hours and minutes
        if (isNaN(hours) || isNaN(minutes) || hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
          throw new Error('Invalid time format. Hours should be 0-23 and minutes 0-59.');
        }

        // Determine if it's AM or PM
        let period = hours >= 12 ? 'PM' : 'AM';

        // Convert hours to 12-hour format
        hours = hours % 12 || 12;

        // Pad minutes with leading zero if necessary
        minutes = minutes.toString().padStart(2, '0');

        // Return the formatted time
        return `${hours}:${minutes} ${period}`;
      }
    },
    editCalendarActivity() {
      this.$router.push({ name: 'CalendarActivityEdit', params: { id: this.selectedEvent.id } })
    },
    deleteCalendarActivity() {
      this.$apiFire("CalendarActivity/destroy", { id: this.selectedEvent.id }).then(res => {
        window.location.reload();
      })
    },
    onDelete() {
      let id = this.selectedEvent.id;
      // sweetalert confirm
      this.$store.commit("General/setModal", {
        theme: "delete",
        title: "ลบข้อมูล ?",
        text: "ท่านยืนยันที่จะลบข้อมูลหรือไม่?",
        buttonText: "ยืนยัน",
        cancelText: "ยกเลิก",
        action: async () => {
          let res = await this.$apiFire("CalendarActivity/delete",id);
          if (res) {
            window.location.reload();
          }
        },
      });
    },
    async prev () {
      const select = addMonths(new Date(this.selectedDate), -1);

      this.selectedDate = select.toISOString().substring(0, 10);
      this.searchMonth = select.getMonth() + 1;
      this.searchYear = select.getFullYear();

      this.getData(this.searchMonth, this.searchYear);

    },
    next () {
      const select = addMonths(new Date(this.selectedDate), 1);

      this.selectedDate = select.toISOString().substring(0, 10);
      this.searchMonth = select.getMonth() + 1;
      this.searchYear = select.getFullYear();

      this.getData(this.searchMonth, this.searchYear);
    },
    canEditEvent(event) {
      const currentUser = this.$store.state.Auth.User;

      // ถ้าเป็น สป และ region เป็น null ก็สามารถแก้ไขได้เฉพาะ user_type ที่ตรงกัน
      if ((event.user_type === "สป.อว." || event.user_type?.includes("สป")) && !event.region) {
        return currentUser.user_type === event.user_type || currentUser.user_type?.includes("สป");
      }

      // ถ้าเป็น RSP ต้อง user_type และ region ตรงกัน
      if (event.user_type === "RSP" && event.region) {
        return currentUser.user_type === "RSP" && currentUser.region === event.region;
      }

      // สำหรับกรณีอื่นๆ ให้เช็ค user_type ที่ตรงกัน
      return currentUser.user_type === event.user_type;
    }
  }
}
</script>

<style>
.theme--light.v-calendar-weekly .v-calendar-weekly__day {
  border-right: #e0e0e0 1px solid;
  border-bottom: #e0e0e0 1px solid;
  color: #000000;
  min-height: 200px;
}
.v-calendar-weekly__day-label {
  text-decoration: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  -webkit-box-shadow: none;
  box-shadow: none;
  text-align: left;
  margin: 4px 0px 0px 8px;
}
.v-calendar-weekly__day-label .v-btn{
  font-size: 18px;
  text-transform: none;
}
.theme--light.v-calendar-weekly,
.theme--light.v-calendar-weekly .v-calendar-weekly__day.v-outside{
  background-color: #fafafa;
}

.theme--light.v-calendar-weekly {
  border-top: #e0e0e0 1px solid;
  border-left: #e0e0e0 1px solid;
  border-right: #e0e0e0 1px solid;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  overflow: hidden;
}
.theme--light.v-calendar-weekly .v-calendar-weekly__day{
  border: #e0e0e0 1px solid;
}

.v-calendar-weekly__head-weekday,
.theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday.v-outside {
  font-size: 24px;
  font-weight: 500;
  color: #000000;
  padding: 18px;
  background-color: #fff;
}
.v-calendar-weekly__head{
  border-radius: 16px;
}
.v-application .pl-1{
  height: 100%;
  display: flex;
  align-items: center
  ;
}
.v-calendar-weekly__day>div{
  margin-bottom: 5px !important;
}
.v-event{
  left: 2.5%
}
.v-calendar-weekly__head-weekday, 
.theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday:not(:last-child){
  border: 0;
}
.v-calendar-weekly__head-weekday{
  text-transform: capitalize;
} 

.v-calendar-weekly__head-weekday.v-present, 
.theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday.v-present{
  background-color: var(--theme-color-seven);
  color: #fff;
  border-radius: 10px;
}
.v-calendar-weekly__head-weekday.v-present.v-present-inactive, 
.theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday.v-present.v-present-inactive{
  background-color: #fff;
  color: #000;
}
.v-calendar-weekly__day.v-present .theme--light.v-btn.v-btn--has-bg{
  background-color: var(--theme-color-seven);
  color: #fff;
}
.theme--light.v-calendar-weekly .v-calendar-weekly__day .event{
  padding-left: 10px
}
.v-calendar .v-event{
  display: flex;
  align-items: center;
  width: 100%;
}

.region-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.region-text {
  font-size: 14px;
  color: #333;
}
</style>